import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { ColumnType } from "./types";

dayjs.extend(customParseFormat);

export const getIdentity = (columns: ColumnType[], orderBy: string | null) => {
  const orderColumn = columns.find(column => column.id === orderBy);
  return (row: Record<string, unknown>) => {
    const element = orderColumn?.orderIdentity
      ? orderColumn.orderIdentity(row)
      : row[orderBy as string];

    if (typeof element === "string") {
      const date = dayjs(element, "YYYY-MM-DDTHH:mm:ssZ", true);
      if (date.isValid()) {
        return date;
      }
      return element.toLocaleLowerCase();
    }
    return element;
  };
};
